import React, { Fragment, useEffect, useState, useCallback } from 'react';

import { api, Auth } from '../api';
import { Authenticator } from './Auth/Authenticator';
import { ListGroup, Button, Modal, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { ReviewableItemListItem } from './ReviewableItem';
import { ItemReviewListItem } from './ItemReview';
import { Spacer } from './Helpers';
import { GeoApifyMap } from './Helpers';
import { ReviewCreator } from './ReviewCreator';


function VendorReviewableItemListItems(props) {
    if(!props.items) {
        return <Fragment></Fragment>;
    }
    return props.items.map(function(item) {
        return (
            <ListGroup.Item key={item.id} style={{border: "none", minWidth: "300px", maxWidth: "300px", marginRight: "12px"}}>
                <ReviewableItemListItem item={item} linkVendor={false} authState={props.authState} />
            </ListGroup.Item>
        );
    });
}

function VendorItemList(props) {
    let history = useHistory();
    if(!props.items) {
        return <Fragment></Fragment>;
    }
    return (
        <Fragment>
            <h4>Menu</h4>
            <ListGroup horizontal style={{maxWidth: "1000px", flexWrap: "wrap"}}>
                <VendorReviewableItemListItems items={props.items} vendor={props.vendor} authState={props.authState}></VendorReviewableItemListItems>
            </ListGroup>
            { props.authState === 'signedIn' &&
                <Button style={{marginTop: "12px"}} onClick={() => history.push('/addDoughnut/'+props.vendor.id)}>Add Doughnut</Button>
            }
        </Fragment>
    );
}

function VendorReviewListItems(props) {
    if(!props.reviews) {
        return <Fragment></Fragment>;
    }
    return props.reviews.map(review => (
        <ListGroup.Item key={review.id} style={{display: "inline-block", paddingLeft: "0px", paddingRight: "0px", paddingBottom: "0px", marginBottom: "48px"}}>
            <ItemReviewListItem review={review} showItemLink={true} showUserLink={true} showVendorLink={false} showVendorMap={false} showFullReview={false}/>
        </ListGroup.Item>
    ));
}

function VendorReviewList(props) {
    if(!props.reviews || props.reviews.length === 0) {
        return <Fragment></Fragment>;
    }
    return (
        <Fragment>
            <h4>Reviews</h4>
            <ListGroup style={{maxWidth: "1002px"}}>
                <VendorReviewListItems reviews={props.reviews}></VendorReviewListItems>
            </ListGroup>
        </Fragment>
    );
}

function FavoriteVendorButton(props) {
    const handleSetFavoriteButtonClick = useCallback(() => {
        async function setFav() {
            try {
                await Auth.currentAuthenticatedUser();
                await api.updateMe({ favVendorId: props.vendorId });
            } catch (err) {
                console.warn("Failed to set favorite vendor", err);
            }
        }
        setFav();
    }, [props.vendorId]);

    return (
        <Fragment>
        { props.authState === 'signedIn' &&
            <Button variant="primary" onClick={handleSetFavoriteButtonClick} style={{ float: "right"}}>Set as favorite shop</Button>
        }
        </Fragment>
    );
}

function AddReviewButton(props) {
    const [showAddReview, setShowAddReview] = useState(false);

    const onAddReviewClicked = useCallback(() => {
        setShowAddReview(true);
    }, []);
    const handleAddReviewModalClosed = useCallback(() => {
        setShowAddReview(false);
    }, []);

    if(!props.vendor) {
        return <Fragment></Fragment>;
    }
    return (
        <Fragment>
        { props.authState === 'signedIn' &&
            <Fragment>
                <Button onClick={onAddReviewClicked}
                    style={{display: "inline-block", verticalAlign: "text-bottom", marginLeft: "6px", marginTop: "6px"}}>
                    Add Review</Button>
                <Spacer height="36px"/>
                <Modal show={showAddReview} onHide={handleAddReviewModalClosed}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <ReviewCreator vendorId={props.vendor.id} items={props.vendor.items} onReviewCompleted={handleAddReviewModalClosed}/>
                    </Modal.Body>
                </Modal>
            </Fragment>
        }
        </Fragment>
    );
}

function VendorMap(props) {
    return (
        <GeoApifyMap width={300} height={300} latitude={props.vendor.latitude} longitude={props.vendor.longitude} zoom={9} />
    );
}

function Vendor(props) {
    return (
        <Fragment>
            <div style={{ padding: "24px 48px 24px 48px", marginTop: "100px", marginBottom: "100px" }}>
                <Authenticator hideDefault="true">
                    <div style={{display: "flex", alignItems: "flex-end"}}>
                        <div style={{display: "inline-block", flexGrow: "1"}}>
                            <h1 style={{display: "inline-block"}}>{props.vendor.name}</h1>
                            <AddReviewButton vendor={props.vendor}></AddReviewButton>
                            <div className="headerTextLight">{props.vendor.description}</div>
                        </div>
                        <div style={{flexGrow: "0"}}>
                            <VendorMap vendor={props.vendor}></VendorMap>
                        </div>
                    </div>
                    <FavoriteVendorButton vendorId={props.vendor.id} />
                    <div style={{height: "24px", borderTop: "1px solid #456" }}/>
                    <VendorItemList items={props.vendor.items} vendor={props.vendor}></VendorItemList>
                    <Spacer height="24px" />
                    <VendorReviewList reviews={props.vendor.reviews} vendor={props.vendor}></VendorReviewList>
                </Authenticator>
            </div>
        </Fragment>
    );
}


function VendorLoader(props) {
    const [vendor, setVendor] = useState(null);

    useEffect(() => {
        api.getVendor(props.id).then(setVendor).catch(() => setVendor(null));
    }, [props.id]);

    if(!vendor) {
        return <Fragment></Fragment>;
    }
    return (
        <Fragment>
            <Vendor vendor={vendor}></Vendor>
        </Fragment>
    );
}

class VendorSearch extends React.Component {
    constructor() {
        super();
        this.state = {
            storeName: "",
            city: "",
            territory: "",
            country: "",
        };
    }

    async updateStoreName(event) {
        event.preventDefault();
        this.setState({ storeName: event.target.value });
    }

    render() {
        return (
            <Fragment>
                <div style={{ padding: "24px 12px 24px 12px", marginTop: "100px", marginBottom: "100px" }}>
                    <h1>Find a Doughnut Provider</h1>
                    <Form noValidate>
                        <Form.Group>
                            <Form.Control style={{ width: "353px", float: "left" }} type="text" placeholder="Store Name" onChange={e => this.updateStoreName(e)}/>
                            <Button variant="primary" type="submit" style={{ float: "right"}}>
                                Find
                            </Button>
                        </Form.Group>
                    </Form>
                </div>
            </Fragment>
        );
    }
}


export { VendorLoader };
